var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsCogDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14563 7.99994C6.14563 9.42742 7.69092 10.3196 8.92714 9.60585C9.50086 9.27458 9.85434 8.66243 9.85434 7.99994C9.85434 6.57246 8.30905 5.68028 7.07284 6.39402C6.49911 6.7253 6.14563 7.33745 6.14563 7.99994Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5453 1.81897H6.45473V3.3012C5.80795 3.51427 5.21218 3.85877 4.70485 4.31305L3.41919 3.57128L1.8739 6.24769L3.15837 6.98946C3.01977 7.65608 3.01977 8.34405 3.15837 9.01067L1.87452 9.75243L3.41981 12.4288L4.70485 11.6871C5.21201 12.1413 5.80755 12.4858 6.45411 12.6989V14.1812H9.54468V12.6989C10.1917 12.486 10.7877 12.1415 11.2952 11.6871L12.5808 12.4288L14.1261 9.75243L12.8417 9.01067C12.9801 8.34405 12.9801 7.65608 12.8417 6.98946L14.1255 6.24769L12.5802 3.57128L11.2952 4.31305C10.7879 3.85877 10.1921 3.51427 9.5453 3.3012V1.81897Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCogDefault);
export default __webpack_public_path__ + "static/media/settings-cog-default.0295608e.svg";
export { ForwardRef as ReactComponent };